import styled from 'styled-components';
import { UIElements } from '@ansvar-sakerhet/ui';

const TableSubRowContainer = styled.div`
  width: 100%;
  display: flex;
`;

const Divider = styled.div`
  width: 20px;
`;

const CompanyInfoPanel = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: auto;
`;

const CompanyInfoContainer = styled.div`
  display: grid;
  padding: 16px;
  padding-top: 48px;
  grid-template-columns: 1fr 4fr;
  gap: 20px;
  width: 100%;
`;

const LeftActions = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1;
`;

const EditTrigger = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  border: none;
  padding: 0px;
  background: none;
  cursor: pointer;
`;

const BackgroundControlsContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  width: 100%;

  &::after {
    content: '';
    position: absolute;
    left: -16px;
    top: 16px;
    bottom: 16px;
    width: 1px;
    background-color: ${({ theme }) => theme.colors.gray};
  }
`;

const EditButtonContainer = styled.div`
  padding: 16px;
`;

const ImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 8px 0;
  width: 100%;
  max-width: 328px;
`;

const Image = styled.img`
  width: 150px;
  height: auto;
  overflow: hidden;
  object-fit: scale;
  border-radius: 2px;
`;

export const S = {
  ...UIElements,
  TableSubRowContainer,
  CompanyInfoPanel,
  CompanyInfoContainer,
  LeftActions,
  EditTrigger,
  BackgroundControlsContainer,
  ImageContainer,
  Image,
  Divider,
  EditButtonContainer,
};
